export default __webpack_public_path__ + "static/media/pokeball.022ced8c.png";